import { render, staticRenderFns } from "./SelectUsergroup.vue?vue&type=template&id=998ac160&"
import script from "./SelectUsergroup.vue?vue&type=script&lang=js&"
export * from "./SelectUsergroup.vue?vue&type=script&lang=js&"
import style0 from "./SelectUsergroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports